import {toastr} from 'react-redux-toastr';

export function toastrErrorHandler(error) {
    if(error.name === 'ServerValidationException') {
        let errors = error.promisedErrors;
        let allErrors = [];
        Object.keys(errors).forEach(fieldName => {
            allErrors = allErrors.concat(errors[fieldName]);
        });

        toastr.error('Fejl', allErrors.join('<br>'), {
            closeButton: true
        });
    } else if (error.message) {
        toastr.error('Fejl', error.message, {
            closeButton: true
        });
    }

    throw  error;
}


// WEBPACK FOOTER //
// ./web/src/actions/utils.js